import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '@mdi/react';
import { mdiRadioboxBlank, mdiRadioboxMarked } from '@mdi/js';
import { setIsolatedViewsOwnerId } from 'client/store/mapSlice/mapSlice';
import { selectSelectedOwnerId, setSelectedOwnerId } from 'client/store/isolatedViewsSlice/isolatedViewsSlice';
import styles from './AssetOwnerAccordionHeader.module.scss';

// Renders the owner selector row that would later own the accordion header behavior.
// Keeping it presentational makes the eventual refactor easier to test and reuse.
const AssetOwnerAccordionHeader = ({ owner, onOwnerSelected, ...props }) => {
    const selectedOwner = useSelector(selectSelectedOwnerId);
    const dispatch = useDispatch();
    const isSelected = selectedOwner === owner.dataProviderId;

    const handleClick = () => {
        if (onOwnerSelected) {
            onOwnerSelected(owner.dataProviderId);
            return;
        }

        dispatch(setSelectedOwnerId(owner.dataProviderId));
        dispatch(setIsolatedViewsOwnerId(owner.dataProviderId));
    };

    const actorName = owner?.label || owner?.actorName || '';

    return (
        <div
            className={[styles.assetOwnerHeading, isSelected ? styles.selected : ''].join(' ')}
            onClick={handleClick}
            {...props}
        >
            <Icon
                path={isSelected ? mdiRadioboxMarked : mdiRadioboxBlank}
                size={0.75}
                className={styles.ownerIcon}
            />
            <span>{actorName}</span>
        </div>
    );
};

AssetOwnerAccordionHeader.propTypes = {
    owner: PropTypes.shape({
        dataProviderId: PropTypes.string,
        label: PropTypes.string,
        actorName: PropTypes.string
    }).isRequired,
    onOwnerSelected: PropTypes.func
};

AssetOwnerAccordionHeader.defaultProps = {
    onOwnerSelected: null
};

export default AssetOwnerAccordionHeader;
